import React, { Component } from 'react'
import { Table, Spin } from 'antd'

class ListItems extends Component {
  getColumns = () => {
    return [
      {
        title: 'ID',
        dataIndex: 'job_id',
        width: '10%'
      },
      {
        title: 'Name',
        dataIndex: 'job_name',
        width: '20%'
      },
      {
        title: 'Address',
        dataIndex: 'address',
        width: '50%'
      },
      {
        title: 'Company',
        dataIndex: 'company_name',
        width: '20%'
      }
    ]
  }

  getData = schedules => {
    return schedules.map((item, index) => {
      item.address = `${item.address1}${item.address2 ? ', ' + item.address2 : ''}, ${item.city}, ${
        item.state
      }`
      item.key = item.id
      return item
    })
  }

  getJobList = () => {
    const { fullReport } = this.props
    let jobList = []

    fullReport.forEach(item => {
      jobList.push(
        <div key={item.monthly_day}>
          <h6 className="steps">
            Targeted Date: {item.monthly_day}
            {item.monthly_day === 1 ? 'st' : 'th'}
          </h6>
          <Table
            pagination={false}
            columns={this.getColumns()}
            dataSource={this.getData(item.schedules)}
            size="small"
            style={{ backgroundColor: 'white' }}
          />
        </div>
      )
    })
    return jobList
  }

  render() {
    const { loadingFullReport, fullReport } = this.props
    return (
      <div>
        {loadingFullReport && <Spin />}
        {!loadingFullReport &&
          fullReport && (
            <div>
              <div style={{ marginTop: 20 }} className="row">
                <div className="col-12">
                  <h5>Targeted Monthly Visit Dates</h5>
                  {this.getJobList()}
                </div>
              </div>
            </div>
          )}
      </div>
    )
  }
}

export default ListItems



// WEBPACK FOOTER //
// ./src/components/reports/maintenance_dob/targeted-monthly-visits/ListItem.js